import { COUNTRIES } from "@/lib/lead";

const base = "w-full bg-[#F5F7FA] border focus:bg-white focus:outline-none px-3 text-sm rounded-sm";
const cls = (err, pad = "py-2.5") => `${base} ${pad} ${err ? "border-red-500 focus:border-red-500" : "border-transparent focus:border-[#007BFF]"}`;

export function FieldError({ msg, id }) {
  if (!msg) return null;
  return <p id={id} role="alert" className="text-xs text-red-600 mt-1" data-testid={id}>{msg}</p>;
}

export function TextField({ prefix, k, lf, label, type = "text", span = "col-span-2 md:col-span-1", pad, autoComplete }) {
  const err = lf.errors[k];
  return (
    <div className={span}>
      <label htmlFor={`${prefix}-${k}`} className="sr-only">{label}</label>
      <input id={`${prefix}-${k}`} type={type} placeholder={label} value={lf.form[k]} onChange={lf.update(k)} autoComplete={autoComplete}
        aria-invalid={!!err} aria-describedby={err ? `${prefix}-${k}-error` : undefined} className={cls(err, pad)} data-testid={`${prefix}-${k}`} />
      <FieldError msg={err} id={`${prefix}-${k}-error`} />
    </div>
  );
}

export function PhoneField({ prefix, lf, pad }) {
  const dial = COUNTRIES.find((c) => c.code === lf.form.countryCode)?.dial;
  return (
    <div className="col-span-2">
      <div className="flex gap-2">
        <label htmlFor={`${prefix}-country`} className="sr-only">Country</label>
        <select id={`${prefix}-country`} value={lf.form.countryCode} onChange={lf.update("countryCode")} autoComplete="country"
          className={`${cls(false, pad)} !w-32 sm:!w-56 shrink-0`} data-testid={`${prefix}-country`}>
          {COUNTRIES.map((c) => <option key={c.code} value={c.code}>{c.name} (+{c.dial})</option>)}
        </select>
        <div className="relative flex-1">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-[#5F6B76] pointer-events-none" data-testid={`${prefix}-dial-code`}>+{dial}</span>
          <label htmlFor={`${prefix}-phone`} className="sr-only">Phone number</label>
          <input id={`${prefix}-phone`} type="tel" inputMode="tel" autoComplete="tel-national" placeholder="Phone *" value={lf.form.phone} onChange={lf.update("phone")}
            aria-invalid={!!lf.errors.phone} aria-describedby={lf.errors.phone ? `${prefix}-phone-error` : undefined}
            className={`${cls(lf.errors.phone, pad)} pl-14`} data-testid={`${prefix}-phone`} />
        </div>
      </div>
      <FieldError msg={lf.errors.phone} id={`${prefix}-phone-error`} />
    </div>
  );
}

export function MessageField({ prefix, lf, label, rows = 4, pad }) {
  const err = lf.errors.message;
  return (
    <div className="col-span-2">
      <label htmlFor={`${prefix}-message`} className="sr-only">{label}</label>
      <textarea id={`${prefix}-message`} placeholder={label} value={lf.form.message} onChange={lf.update("message")} rows={rows}
        aria-invalid={!!err} className={cls(err, pad)} data-testid={`${prefix}-message`} />
      <FieldError msg={err} id={`${prefix}-message-error`} />
    </div>
  );
}
